import {Base} from "@/api/Base"

export class ReportEdit extends Base {
    path = "report/edit"
}